import React from 'react';
import {
  ContentWrapper,
  DeploymentWrapper,
  Footer,
  SuccessInfo,
  SuccessTitle,
  Title,
} from '@src/pages/workflow/components/Deployment/styled';
import { Button, Form } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { useFlowStore } from '@src/pages/workflow/store/flowBuilder';
import { InfoCircleFilled, LoadingOutlined, CheckOutlined } from '@ant-design/icons';
import { useMetricBuilderStore } from '@src/emp-3.0/components/Metrics/IndividualMetric/store';

const Deployment = () => {
  const {
    resetAll,
    setActiveTool,
    deploymentStatus,
    formInstance: flowFormInstance,
  } = useFlowStore();
  const { id, type } = useParams();
  const { formInstance: metricFormInstance } = useMetricBuilderStore();

  const isFlow = type === 'flow';
  const isPattern = type === 'pattern';

  const navigate = useNavigate();
  const formInstance = isFlow || isPattern ? flowFormInstance : metricFormInstance;
  const successTitle = `Deploy 1 ${type} successfully!`;

  const flowName = Form.useWatch('name', formInstance);

  const handleBuildNewFlow = () => {
    const path = `/workflow/${type}/new`;
    // navigate(path);
    // TODO: find the right way to navigate
    location.href = `/app/activation${path}`;
  };

  return (
    <DeploymentWrapper>
      <Title>Deployment Confirmation</Title>
      <ContentWrapper as={'div'} status={deploymentStatus}>
        {deploymentStatus === 'inprogress' && (
          <div>
            <LoadingOutlined style={{ marginRight: '8px' }} />
            <span>Deployment in progress.This may take a few moments</span>
          </div>
        )}
        {deploymentStatus === 'success' && (
          <div>
            <SuccessTitle>{successTitle}</SuccessTitle>
            <SuccessInfo>
              <CheckOutlined
                style={{ color: 'rgba(0, 0, 0, 0.88)', fontSize: '12px', marginRight: '8px' }}
              />{' '}
              {flowName}
            </SuccessInfo>
          </div>
        )}
        {deploymentStatus === 'failed' && (
          <>
            <div>
              <InfoCircleFilled style={{ color: '#F5222D', fontSize: '14px' }} />
            </div>
            <div>
              <div>Oops! The deployment didn’t complete successfully.</div>
              <div>Please try again or contact support.</div>
            </div>
          </>
        )}
      </ContentWrapper>
      <Footer>
        {deploymentStatus === 'failed' && (
          <Button onClick={() => setActiveTool(null)}>Close</Button>
        )}
        {deploymentStatus === 'success' && (
          <>
            <Button onClick={handleBuildNewFlow}>
              Build a New {isPattern ? 'Pattern' : isFlow ? 'Flow' : 'Metric'}
            </Button>
            <Button
              type="primary"
              ghost
              onClick={() => {
                const path = `/metric-builder/${type}/${id}`;
                navigate(path);
              }}
            >
              Exit
            </Button>
          </>
        )}
      </Footer>
    </DeploymentWrapper>
  );
};

export default Deployment;
